import React from "react";
import { useTranslation } from "react-i18next";

import { TComboVariants } from "redux/reducers/models/product";

import Sheet from "components/sheet/Sheet";
import Input from "components/form/input/Input";
import FormLayout from "components/form/FormLayout";

type UpdateProductAsComboProps = {
  isVisible: boolean;
  onCancel: () => void;
  onOk: (comboId: number, cost: string, price: string, quantity: string) => void;
  combo: TComboVariants;
  handleUpdates: (newState: Partial<{ selectedComboVariant: TComboVariants }>) => void;
  currencySymbol?: string;
  isDynamic?: boolean;
};

export default function UpdateProductAsComboModal(props: UpdateProductAsComboProps) {
  const { t } = useTranslation();

  return (
    <Sheet
      open={props.isVisible}
      title={`${t("secure.facility.product.update_product_ascombo_modal.001")} '${props.combo.product.title}' ${t(
        "secure.facility.product.update_product_ascombo_modal.002",
      )}`}
      size="small"
      closable
      onCancel={() => props.onCancel()}
      cancelText={t("secure.facility.product.update_product_ascombo_modal.003")}
      backDropCancel={false}
      onOk={() => props.onOk(props.combo.id, props.combo.combo_pivot.cost, props.combo.combo_pivot.price, props.combo.combo_pivot.quantity)}
      okText={t("secure.facility.product.update_product_ascombo_modal.004")}
    >
      <FormLayout>
        <FormLayout.Group>
          <Input
            id={"price"}
            label={t("secure.facility.product.update_product_ascombo_modal.005")}
            value={props.combo?.combo_pivot.price || ""}
            type={"number"}
            onChange={e =>
              props.handleUpdates({
                selectedComboVariant: {
                  ...props.combo,
                  combo_pivot: {
                    ...props.combo.combo_pivot,
                    price: e.target.value,
                  },
                },
              })
            }
            placeholder="0.00"
            prefix={props.currencySymbol ?? "$"}
          />

          <Input
            id={"cost"}
            label={t("secure.facility.product.update_product_ascombo_modal.006")}
            value={props.combo?.combo_pivot.cost || ""}
            type={"number"}
            onChange={e =>
              props.handleUpdates({
                selectedComboVariant: {
                  ...props.combo,
                  combo_pivot: {
                    ...props.combo.combo_pivot,
                    cost: e.target.value,
                  },
                },
              })
            }
            placeholder="0.00"
            prefix={props.currencySymbol ?? "$"}
          />
        </FormLayout.Group>
        {props.isDynamic !== true &&
          <FormLayout.Group>
            <Input
              id={"quantity"}
              label={t("Quantity")}
              value={props.combo?.combo_pivot.quantity || ""}
              type={"number"}
              onChange={e =>
                props.handleUpdates({
                  selectedComboVariant: {
                    ...props.combo,
                    combo_pivot: {
                      ...props.combo.combo_pivot,
                      quantity: e.target.value,
                    },
                  },
                })
              }
            />
          </FormLayout.Group>
        }
      </FormLayout>
    </Sheet>
  );
}
